import { regular, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@material-ui/core';
import React from 'react';
import styles from './styles';
import cx from 'classnames';
import { translate } from '../../../../../common/intl';

interface Props {
  displayValue: string
  onEdit: () => void
  onReplace?: () => void
  onDelete?: () => void
}

const DisplayComponent: React.FC<Props> = ({
  displayValue,
  onEdit,
  onReplace,
  onDelete,
}) => {
  const classes = styles();
  const [isHovered, setIsHovered] = React.useState(false);
  const [isEditIconHovered, setIsEditIconHovered] = React.useState(false);
  const [isReplaceIconHovered, setIsReplaceIconHovered] = React.useState(false);
  const [isDeleteIconHovered, setIsDeleteIconHovered] = React.useState(false);

  return (
    <div
      className={classes.boxContainer}
      onMouseOver={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
      <span className={classes.span}>
        {displayValue}
      </span>
      {isHovered && (
        <>
        {onEdit && (
        <Tooltip title={translate('common.edit')}>
          <FontAwesomeIcon
            icon={isEditIconHovered ? solid('pen-to-square') : regular('pen-to-square')}
            className={cx(classes.editIcon, { [classes.editIconDisable]: !isEditIconHovered })}
            onMouseEnter={() => setIsEditIconHovered(true)}
            onMouseLeave={() => setIsEditIconHovered(false)}
            onClick={onEdit}
          />
        </Tooltip>
        )}
        {onReplace && (
        <Tooltip title={translate('common.replace')}>
          <FontAwesomeIcon
            icon={isReplaceIconHovered ? solid('repeat') : regular('repeat')}
            className={cx(classes.editIcon, { [classes.editIconDisable]: !isReplaceIconHovered })}
            onMouseEnter={() => setIsReplaceIconHovered(true)}
            onMouseLeave={() => setIsReplaceIconHovered(false)}
            onClick={onReplace}
          />
        </Tooltip>
        )}
        {onDelete && (
        <Tooltip title={translate('common.retire')}>
          <FontAwesomeIcon
            icon={isDeleteIconHovered ? solid('square-minus') : regular('square-minus')}
            className={cx(classes.editIcon, classes.deleteIcon, { [classes.editIconDisable]: !isDeleteIconHovered })}
            onMouseEnter={() => setIsDeleteIconHovered(true)}
            onMouseLeave={() => setIsDeleteIconHovered(false)}
            onClick={onDelete}
          />
        </Tooltip>
        )}
        </>
      )}
    </div>
  );
};

export default DisplayComponent;
